import React from 'react';
import CreateEditCampaign from './Components/CreateEditCampaign';
import PageHeading from '../../Components/PageHeading';
import { Modal, Stack, Typography } from '@mui/material';
import { CloseIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../Routes/Pathname';


export default function EditCampaign({ fetch }) {
	const navigate = useNavigate();
	const location = useLocation();
	// console.log('location', location);
	const fromDashboard = location.state?.fromDashboard || false;
	
	const campaign = location.state?.campaign || null;

	return (
		<Stack position={'relative'} width="100%" height="100%" overflow="hidden">
			<Stack sx={{padding: '20px 20px 0px 20px'}} direction="row" alignItems="flex-start" justifyContent="space-between">
				<PageHeading
					title={campaign?.copy ? 'Create Duplicate Campaign' : campaign ? 'Edit Campaign' : 'Create New Campaign'}
					subTitle={
						campaign?.copy
							? 'Easily replicate settings for previous campaign'
							: campaign
							? 'Edit campaign details'
							: 'Set up a brand-new campaign tailored to your objectives.'
					}
				/>

				{/* <CloseIcon onClick={() => navigate(-1)} color="#98A2B3" size={24} /> */}
			</Stack>
			<CreateEditCampaign
				edit={!!campaign && !campaign.copy}
				isNewCampaign={!campaign}
				setOpen={() => { fromDashboard ? navigate(PATH_NAME.DASHBOARD) : navigate(PATH_NAME.CAMPAIGN_LIST) }}
				fetch={fetch}
				campaignData={campaign}
			/>
		</Stack>
	);
}
